module.exports = __webpack_public_path__ + "img/28.dc8b4497.jpg";